<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [label]="'FONT_STYLE'">
  <div app-theme-option-content>
    <app-theme-option-font-style [fontStyle]="themeOptions.options().tooltips.bodyFontStyle" (sendFontStyle)="receiveValue($event)"></app-theme-option-font-style>
  </div>
</app-theme-option>